import { Organization } from '@brands/services/identity/types/UserProfile';

import { RootState } from '../store';

export const selectOrganization = (state: RootState): any => state.organization;

export const selectCurrentOrganization = (state: RootState): Organization | null =>
  state.organization.currentOrganization;
